export default "__VITE_ASSET__BvQkSmz0__"